export function isDateValid(dateStr) {
  return !!dateStr && !isNaN(new Date(dateStr).getDate());
}
export default isDateValid;